// import axios from 'axios';
// import axiosRetry from 'axios-retry';
import * as actions from "./actionsTypes";
import errorManage from "../errorManage";
import messages from "../messages";
import toastr from "toastr";
import jobPositionServices from "./jobPosition.services";
// const client = axios.create({ baseURL: process.env.REACT_APP_URL });
// axiosRetry(client, { retries: 5, retryDelay: axiosRetry.exponentialDelay });

export const getJobPositions = (filters, iType) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_JOB_POSITIONS,
        payload: true,
      });
      // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
      // const resp = await client.get(iType === 1 ? '/api/app/Formal_Puesto/' : '/api/app/Funcional_Puesto/', {
      //   headers: {
      //     'Content-Type': 'application/json',
      //     'Authorization': `Token ${token}`
      //   },
      //   params: data
      // });
      const resp = await jobPositionServices.getJobPositions(filters, iType);
      dispatch({
        type: actions.GET_JOB_POSITIONS,
        payload: {
          jobPositions: resp.data.data,
          jobPositionsLength: resp.data.count,
        },
      });
      dispatch({
        type: actions.JOB_POSITIONS_FAIL,
        payload: "",
      });
    } catch (ex) {
      let message = null;
      if (ex.response) {
        if (ex.response.status === 400) {
          if (Array.isArray(ex.response.data)) {
            ex.response.data.forEach((item) => {
              toastr.error(item);
            });
          } else {
            toastr.error(ex.response.data);
          }
          message = ex.response.data.mensaje;
        } else {
          errorManage(ex);
          message = messages.errorMessage;
        }
      } else {
        errorManage(ex);
        message = messages.errorMessage;
      }
      dispatch({
        type: actions.JOB_POSITIONS_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_JOB_POSITIONS,
        payload: false,
      });
    }
  };

export const saveJobPosition = (req, iType, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADING_JOB_POSITIONS,
        payload: true,
      });
      // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
      // const resp = await client.post(iType === 1 ? '/api/app/Formal_Puesto/' : '/api/app/Funcional_Puesto/', data, {
      //   headers: {
      //     'Content-Type': 'application/json',
      //     'Authorization': `Token ${token}`
      //   }});
      const resp = await jobPositionServices.saveJobPosition(req, iType);
      const { jobPositions, jobPositionsLength } = getState().jobPositions;
      const aJobPositions = [...jobPositions, resp.data];
      dispatch({
        type: actions.GET_JOB_POSITIONS,
        payload: {
          jobPositions: aJobPositions,
          jobPositionsLength: jobPositionsLength + 1,
        },
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      toastr.success(messages.successMessage);
    } catch (ex) {
      let message = null;
      if (ex.response) {
        if (ex.response.status === 400) {
          if (Array.isArray(ex.response.data)) {
            ex.response.data.forEach((item) => {
              toastr.error(item);
            });
          } else {
            toastr.error(ex.response.data);
          }
          message = ex.response.data.mensaje;
        } else if (ex.response.status === 409) {
          toastr.error(messages.recordAlreadyExists);
          message = messages.recordAlreadyExists;
        } else {
          errorManage(ex);
          message = messages.errorMessage;
        }
      }else {
        errorManage(ex);
        message = messages.errorMessage;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      setShowModal(false);
      dispatch({
        type: actions.SAVE_LOADING_JOB_POSITIONS,
        payload: false,
      });
    }
  };

export const editJobPosition = (req, id, index, iType, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADING_JOB_POSITIONS,
        payload: true,
      });

      // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
      // const resp = await client.put(iType === 1 ? `/api/app/Formal_Puesto/${id}/` : `/api/app/Funcional_Puesto/${id}/`, data, {
      // headers: {
      //   'Content-Type': 'application/json',
      //   'Authorization': `Token ${token}`
      // }});
      const resp = await jobPositionServices.editJobPosition(id, req, iType);
      const { jobPositions, jobPositionsLength } = getState().jobPositions;
      jobPositions[index] = resp.data;
      //const aJobPositions = [...jobPositions, resp.data];
      dispatch({
        type: actions.GET_JOB_POSITIONS,
        payload: {
          jobPositions: jobPositions,
          jobPositionsLength: jobPositionsLength,
        },
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      toastr.success(messages.successMessage);
    } catch (ex) {
      let message = null;
      if (ex.response) {
        if (ex.response.status === 400) {
          if (Array.isArray(ex.response.data)) {
            ex.response.data.forEach((item) => {
              toastr.error(item);
            });
          } else {
            toastr.error(ex.response.data);
          }
          message = ex.response.data.mensaje;
        } else {
          errorManage(ex);
          message = messages.errorMessage;
        }
      } else {
        errorManage(ex);
        message = messages.errorMessage;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      setShowModal(false);
      dispatch({
        type: actions.SAVE_LOADING_JOB_POSITIONS,
        payload: false,
      });
    }
  };

export const deleteJobPosition = (id, index, iType) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_JOB_POSITIONS,
        payload: true,
      });

      // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
      // await client.delete(iType === 1 ? `/api/app/Formal_Puesto/${id}/` : `/api/app/Funcional_Puesto/${id}/`, {
      // headers: {
      //   'Content-Type': 'application/json',
      //   'Authorization': `Token ${token}`
      // }});
      await jobPositionServices.editJobPosition(id, iType);
      const { jobPositions, jobPositionsLength } = getState().jobPositions;
      jobPositions.splice(index, 1);
      //const aJobPositions = [...jobPositions, resp.data];
      dispatch({
        type: actions.GET_JOB_POSITIONS,
        payload: {
          jobPositions: jobPositions,
          jobPositionsLength: jobPositionsLength - 1,
        },
      });
      dispatch({
        type: actions.JOB_POSITIONS_FAIL,
        payload: "",
      });
      toastr.success(messages.successMessage);
    } catch (ex) {
      let message = null;
      if (ex.response) {
        if (ex.response.status === 400) {
          if (Array.isArray(ex.response.data)) {
            ex.response.data.forEach((item) => {
              toastr.error(item);
            });
          } else {
            toastr.error(ex.response.data);
          }
          message = ex.response.data.mensaje;
        } else {
          errorManage(ex);
          message = messages.errorMessage;
        }
      } else {
        errorManage(ex);
        message = messages.errorMessage;
      }
      dispatch({
        type: actions.JOB_POSITIONS_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_JOB_POSITIONS,
        payload: false,
      });
    }
  };
